import React, { useEffect, useRef } from 'react';
import '../../styles/confirm-modal.css';

interface ConfirmModalProps {
  visible: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  visible,
  title = '确认操作',
  message,
  confirmText = '确定',
  cancelText = '取消',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  const confirmBtnRef = useRef<HTMLButtonElement>(null);

  // 打开时自动聚焦确认按钮，支持 Enter 快速确认
  useEffect(() => {
    if (visible) {
      // 延迟聚焦，等动画开始
      const timer = setTimeout(() => confirmBtnRef.current?.focus(), 50);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [visible]);

  // ESC 关闭
  useEffect(() => {
    if (!visible) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [visible, onCancel]);

  if (!visible) return null;

  return (
    <div className="ai-svg-confirm-backdrop" onClick={onCancel}>
      <div className="ai-svg-confirm-modal" onClick={(e) => e.stopPropagation()}>
        {/* 图标 */}
        <div className={`ai-svg-confirm-icon ${danger ? 'ai-svg-confirm-icon--danger' : 'ai-svg-confirm-icon--info'}`}>
          {danger ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M10 11v6" />
              <path d="M14 11v6" />
            </svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          )}
        </div>

        {/* 文案 */}
        <div className="ai-svg-confirm-title">{title}</div>
        <div className="ai-svg-confirm-message">{message}</div>

        {/* 按钮 */}
        <div className="ai-svg-confirm-actions">
          <button className="ai-svg-confirm-btn ai-svg-confirm-btn--cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button
            ref={confirmBtnRef}
            className={`ai-svg-confirm-btn ${danger ? 'ai-svg-confirm-btn--danger' : 'ai-svg-confirm-btn--primary'}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;